module.exports = {"230230100":"克东镇","230230101":"宝泉镇","230230102":"乾丰镇","230230103":"玉岗镇","230230104":"蒲峪路镇","230230202":"润津乡","230230204":"昌盛乡","230230400":"第一苗圃","230230401":"第二苗圃","230230402":"爱华林场","230230403":"发展林场","230230404":"东兴林场","230230580":"红旗奶山羊场","230230581":"第一良种场","230230582":"第二良种繁殖场","230230583":"果树繁殖场","230230584":"种猪场","230230585":"黑龙江省社会救助安置中心"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230230.json
// module id = 703
// module chunks = 0